<template>
  <div>
    <div v-if="!isEdit">
      <h6 class="font-weight-bold">Volume Current Month</h6>
      <b-table
        class="mt-2 p-0"
        table-class="table-overburden"
        thead-class="bg-color text-center"
        empty-text="No data"
        :items="detailCurrentMonth"
        :fields="fields"
        responsive
        show-empty
        bordered
      >
        <template #thead-top>
          <b-tr>
            <b-th rowspan="2">Pit</b-th>
            <b-th rowspan="2" style="width: 170px">Type OB</b-th>
            <b-th rowspan="2">Status Payment</b-th>
            <b-th rowspan="2">Actual Distance</b-th>
            <b-th rowspan="2">Volume OB</b-th>
            <b-th rowspan="2">Unit Price (IDR/Ton)</b-th>
            <b-th rowspan="2">Total Price (IDR/Ton)</b-th>
            <b-th colspan="5" class="text-center">Budget Number</b-th>
          </b-tr>
        </template>
        <template v-slot:cell(pit)="items">
          <div
            :class="!!items.item.volume_item.find(i => i.status_payment.key === 'Pay') ? 'pay-background' : 'pending-background'"
          >
            <p class="mt-2 mx-2 font-weight-bold">{{ items.item.pit }}</p>
          </div>
        </template>
        <template v-slot:cell(type_ob)="items">
          <div
            v-for="(n, i) in items.item.volume_item.length + 1"
            :key="i"
            class="p-3 m-0"
            :class="i === items.item.volume_item.length ? '' : 'border-bottom'"
            :style="i !== items.item.volume_item.length ? items.item.volume_item[i].status_payment.key === 'Pay' ? 'background-color: #E9FBF9' : 'background-color: #EAE7F3' : 'background-color: #9ed7d2;color: #9ed7d2'"
          >
            {{
              n !== items.item.volume_item.length + 1
                ? items.item.volume_item[i].type
                : '.'
            }}
          </div>
        </template>
        <template v-slot:cell(status_payment)="items">
          <div
            v-for="(n, i) in items.item.volume_item.length + 1"
            :key="i"
            class="p-3 m-0"
            :class="i === items.item.volume_item.length ? '' : 'border-bottom'"
            :style="i !== items.item.volume_item.length ? items.item.volume_item[i].status_payment.key === 'Pay' ? 'background-color: #E9FBF9' : 'background-color: #EAE7F3' : 'background-color: #9ed7d2;color: #9ed7d2'"
          >
            {{
              n !== items.item.volume_item.length + 1
                ? items.item.volume_item[i].status_payment.key
                : '.'
            }}
          </div>
        </template>
        <template v-slot:cell(actual_distance)="items">
          <div
            v-for="(n, i) in items.item.volume_item.length + 1"
            :key="i"
            class="p-3 m-0"
            :class="i === items.item.volume_item.length ? '' : 'border-bottom'"
            :style="i !== items.item.volume_item.length ? items.item.volume_item[i].status_payment.key === 'Pay' ? 'background-color: #E9FBF9' : 'background-color: #EAE7F3' : 'background-color: #9ed7d2; color: #E9FBF9'"
          >
            {{
              n !== items.item.volume_item.length + 1
                ? formatMoney(
                    parseFloat(items.item.volume_item[i].actual_distance),
                    { symbol: '', precision: '2', thousand: ',' }
                  )
                  || 0
                : '.'
            }}
          </div>
        </template>
        <template v-slot:cell(volume)="items">
          <div
            v-for="(n, i) in items.item.volume_item.length + 1"
            :key="i"
            class="p-3"
            :class="i === items.item.volume_item.length ? '' : 'border-bottom'"
            :style="i !== items.item.volume_item.length ? items.item.volume_item[i].status_payment.key === 'Pay' ? 'background-color: #E9FBF9' : 'background-color: #EAE7F3' : 'background-color: #9ed7d2;font-weight: bold'"
          >
            {{
              n !== items.item.volume_item.length + 1
                ? formatMoney(
                    parseFloat(
                      items.item.volume_item[i].volume),
                      { symbol: '', precision: '2', thousand: ',' })
                  || 0
                : formatMoney(
                    parseFloat(subTotal(items.item.volume_item, 'volume')),
                    { symbol: '', precision: '2', thousand: ',' }
                  )
            }}
          </div>
        </template>
        <template v-slot:cell(unit_price)="items">
          <div
            v-for="(n, i) in items.item.volume_item.length + 1"
            :key="i"
            class="p-3"
            :class="i === items.item.volume_item.length ? '' : 'border-bottom'"
            :style="i !== items.item.volume_item.length ? items.item.volume_item[i].status_payment.key === 'Pay' ? 'background-color: #E9FBF9' : 'background-color: #EAE7F3' : 'background-color: #9ed7d2; color: #E9FBF9'"
          >
            {{
              n !== items.item.volume_item.length + 1
                ? formatMoney(
                    parseFloat(
                      items.item.volume_item[i].unit_price),
                      { symbol: '', precision: '2', thousand: ',' })
                  || 0
                : '.'
            }}
          </div>
        </template>
        <template v-slot:cell(total_price)="items">
          <div
            v-for="(n, i) in items.item.volume_item.length + 1"
            :key="i"
            class="p-3"
            :class="i === items.item.volume_item.length ? '' : 'border-bottom'"
            :style="i !== items.item.volume_item.length ? items.item.volume_item[i].status_payment.key === 'Pay' ? 'background-color: #E9FBF9' : 'background-color: #EAE7F3' : 'background-color: #9ed7d2;font-weight: bold'"
          >
            {{
              n !== items.item.volume_item.length + 1
                ? formatMoney(
                    parseFloat(
                      items.item.volume_item[i].total_price),
                      { symbol: '', precision: '2', thousand: ',' })
                  || 0
                : formatMoney(
                    parseFloat(subTotal(items.item.volume_item, 'total_price')),
                    { symbol: '', precision: '2', thousand: ',' }
                  )
            }}
          </div>
        </template>
        <template v-slot:cell(budget_number_cc)="items">
          <div
            v-for="(n, i) in items.item.volume_item.length + 1"
            :key="i"
            class="p-3"
            :class="i === items.item.volume_item.length ? '' : 'border-bottom'"
            :style="i !== items.item.volume_item.length ? items.item.volume_item[i].status_payment.key === 'Pay' ? 'background-color: #E9FBF9' : 'background-color: #EAE7F3' : 'background-color: #fff'"
          >
            {{
              n !== items.item.volume_item.length + 1
                ? items.item.volume_item[i].budget_number_cc ? items.item.volume_item[i].budget_number_cc : '-'
                : ''
            }}
          </div>
        </template>
        <template v-slot:cell(budget_number_plan)="items">
          <div
            v-for="(n, i) in items.item.volume_item.length + 1"
            :key="i"
            class="p-3"
            :class="i === items.item.volume_item.length ? '' : 'border-bottom'"
            :style="i !== items.item.volume_item.length ? items.item.volume_item[i].status_payment.key === 'Pay' ? 'background-color: #E9FBF9' : 'background-color: #EAE7F3' : 'background-color: #fff'"
          >
            {{
              n !== items.item.volume_item.length + 1
                ? items.item.volume_item[i].budget_number_plan ? items.item.volume_item[i].budget_number_plan : '-'
                : ''
            }}
          </div>
        </template>
        <template v-slot:cell(budget_number_ac)="items">
          <div
            v-for="(n, i) in items.item.volume_item.length + 1"
            :key="i"
            class="p-3"
            :class="i === items.item.volume_item.length ? '' : 'border-bottom'"
            :style="i !== items.item.volume_item.length ? items.item.volume_item[i].status_payment.key === 'Pay' ? 'background-color: #E9FBF9' : 'background-color: #EAE7F3' : 'background-color: #fff'"
          >
            {{
              n !== items.item.volume_item.length + 1
                ? items.item.volume_item[i].budget_number_ac ? items.item.volume_item[i].budget_number_ac : '-'
                : ''
            }}
          </div>
        </template>
        <template v-slot:cell(budget_number_sub_ac)="items">
          <div
            v-for="(n, i) in items.item.volume_item.length + 1"
            :key="i"
            class="p-3"
            :class="i === items.item.volume_item.length ? '' : 'border-bottom'"
            :style="i !== items.item.volume_item.length ? items.item.volume_item[i].status_payment.key === 'Pay' ? 'background-color: #E9FBF9' : 'background-color: #EAE7F3' : 'background-color: #fff'"
          >
            {{
              n !== items.item.volume_item.length + 1
                ? items.item.volume_item[i].budget_number_sub_ac ? items.item.volume_item[i].budget_number_sub_ac : '-'
                : ''
            }}
          </div>
        </template>
        <template v-slot:cell(budget_number_pa)="items">
          <div
            v-for="(n, i) in items.item.volume_item.length + 1"
            :key="i"
            class="p-3"
            :class="i === items.item.volume_item.length ? '' : 'border-bottom'"
            :style="i !== items.item.volume_item.length ? items.item.volume_item[i].status_payment.key === 'Pay' ? 'background-color: #E9FBF9' : 'background-color: #EAE7F3' : 'background-color: #fff'"
          >
            {{
              n !== items.item.volume_item.length + 1
                ? items.item.volume_item[i].budget_number_pa ? items.item.volume_item[i].budget_number_pa : '-'
                : ''
            }}
          </div>
        </template>
      </b-table>
      <br>
      <h6 class="font-weight-bold">List Pending From Previous Month</h6>
      <b-table
        class="mt-2 p-0"
        thead-class="bg-color text-center"
        empty-text="No data"
        :items="detailPreviousMonth"
        :fields="previousMonthFields"
        responsive
        show-empty
        bordered
      >
        <template #thead-top>
          <b-tr>
            <b-th rowspan="2" style="width:150px">Month</b-th>
            <b-th rowspan="2">Pit</b-th>
            <b-th rowspan="2">Type OB</b-th>
            <b-th rowspan="2" style="width:200px">Status Payment</b-th>
            <b-th rowspan="2">Actual Distance</b-th>
            <b-th rowspan="2">Volume OB</b-th>
            <b-th rowspan="2">Unit Price (IDR/Ton)</b-th>
            <b-th rowspan="2">Total Price (IDR/Ton)</b-th>
            <b-th colspan="5" class="text-center">Budget Number</b-th>
          </b-tr>
        </template>
        <template v-slot:cell(periode_doc)="items">
          <div
            class="p-2 color-date"
            :class="!!items.item.status_payment.key === 'Pay' ? 'pay-background' : 'pending-background'"
          >
            <p class="mt-2 font-weight-bold">{{ items.item.periode_doc }}</p>
          </div>
        </template>
        <template v-slot:cell(pit)="items">
          <div
            class="p-2"
            :class="!!items.item.status_payment.key === 'Pay' ? 'pay-background' : 'pending-background'"
          >
            <p class="mt-2 font-weight-bold">{{ items.item.pit }}</p>
          </div>
        </template>
        <template v-slot:cell(type_ob)="items">
          <div
            class="p-2"
            :class="!!items.item.status_payment.key === 'Pay' ? 'pay-background' : 'pending-background'"
          >
            <p class="mt-2">{{ items.item.type }}</p>
          </div>
        </template>
        <template v-slot:cell(status_payment)="items">
          <div
            class="p-2"
            style="width: 200px"
            :class="!!items.item.status_payment.key === 'Pay' ? 'pay-background' : 'pending-background'"
          >
            <p class="mt-2">{{ items.item.status_payment.label }}</p>
          </div>
        </template>
        <template v-slot:cell(actual_distance)="items">
          <div
            class="p-2"
            :class="!!items.item.status_payment.key === 'Pay' ? 'pay-background' : 'pending-background'"
          >
            <p class="mt-2">{{ formatMoney(parseFloat(items.item.actual_distance), { symbol: '', precision: '2', thousand: ',' }) }}</p>
          </div>
        </template>
        <template v-slot:cell(volume)="items">
          <div
            class="p-2"
            :class="!!items.item.status_payment.key === 'Pay' ? 'pay-background' : 'pending-background'"
          >
            <p class="mt-2">{{ formatMoney(parseFloat(items.item.volume), { symbol: '', precision: '2', thousand: ',' }) }}</p>
          </div>
        </template>
        <template v-slot:cell(unit_price)="items">
          <div
            class="p-2"
            :class="!!items.item.status_payment.key === 'Pay' ? 'pay-background' : 'pending-background'"
          >
            <p class="mt-2">{{ formatMoney(parseFloat(items.item.unit_price), { symbol: '', precision: '2', thousand: ',' }) }}</p>
          </div>
        </template>
        <template v-slot:cell(total_price)="items">
          <div
            class="p-2"
            :class="!!items.item.status_payment.key === 'Pay' ? 'pay-background' : 'pending-background'"
          >
            <p class="mt-2">{{ formatMoney(parseFloat(items.item.total_price), { symbol: '', precision: '2', thousand: ',' }) }}</p>
          </div>
        </template>
        <template v-slot:cell(budget_number_cc)="items">
          <div
            class="p-2"
            :class="!!items.item.status_payment.key === 'Pay' ? 'pay-background' : 'pending-background'"
          >
            <p class="mt-2">{{ items.item.budget_number_cc || '-' }}</p>
          </div>
        </template>
        <template v-slot:cell(budget_number_plan)="items">
          <div
            :class="!!items.item.status_payment.key === 'Pay' ? 'pay-background' : 'pending-background'"
          >
            <p class="mt-2">{{ items.item.budget_number_plan || '-' }}</p>
          </div>
        </template>
        <template v-slot:cell(budget_number_ac)="items">
          <div
            :class="!!items.item.status_payment.key === 'Pay' ? 'pay-background' : 'pending-background'"
          >
            <p class="mt-2">{{ items.item.budget_number_ac || '-' }}</p>
          </div>
        </template>
        <template v-slot:cell(budget_number_sub_ac)="items">
          <div
            :class="!!items.item.status_payment.key === 'Pay' ? 'pay-background' : 'pending-background'"
          >
            <p class="mt-2">{{ items.item.budget_number_sub_ac || '-' }}</p>
          </div>
        </template>
        <template v-slot:cell(budget_number_pa)="items">
          <div
            :class="!!items.item.status_payment.key === 'Pay' ? 'pay-background' : 'pending-background'"
          >
            <p class="mt-2">{{ items.item.budget_number_plan || '-' }}</p>
          </div>
        </template>
        <template v-slot:custom-foot>
          <tr class="bg-color text-center">
            <td class="font-weight-bold">Sub Total</td>
            <td></td>
            <td></td>
            <td></td>
            <td>
              {{
                formatMoney(
                  parseFloat(subTotal(detailPreviousMonth, 'actual_distance')),
                  { symbol: '', precision: '2', thousand: ',' }
                )
              }}
            </td>
            <td>
              {{
                formatMoney(
                  parseFloat(subTotal(detailPreviousMonth, 'volume')),
                  { symbol: '', precision: '2', thousand: ',' }
                )
              }}
            </td>
            <td>
              {{
                formatMoney(
                  parseFloat(subTotal(detailPreviousMonth, 'unit_price')),
                  { symbol: '', precision: '2', thousand: ',' }
                )
              }}
            </td>
            <td>
              {{
                formatMoney(
                  parseFloat(subTotal(detailPreviousMonth, 'total_price')),
                  { symbol: '', precision: '2', thousand: ',' }
                )
              }}
            </td>
            <td colspan="5"></td>
          </tr>
        </template>
      </b-table>
    </div>
    <div v-if="isEdit">
      <h5>Volume Current Month</h5>
      <b-table
        class="mt-2 p-0"
        table-class="table-overburden"
        thead-class="bg-color text-center"
        empty-text="No data"
        :items="detailCurrentMonth"
        :fields="fields"
        ref="editCurrTable"
        responsive
        show-empty
        bordered
      >
        <template #thead-top>
          <b-tr>
            <b-th rowspan="2">Pit</b-th>
            <b-th rowspan="2" style="width: 170px">Type OB</b-th>
            <b-th rowspan="2">Status Payment</b-th>
            <b-th rowspan="2">Actual Distance</b-th>
            <b-th rowspan="2">Volume OB</b-th>
            <b-th rowspan="2">Unit Price (IDR/Ton)</b-th>
            <b-th rowspan="2">Total Price (IDR/Ton)</b-th>
            <b-th colspan="5" class="text-center">Budget Number</b-th>
          </b-tr>
        </template>
        <template v-slot:cell(pit)="{ item }">
          <div
            :class="!!item.volume_item.find(i => i.status_payment.key === 'Pay') ? 'pay-background' : 'pending-background'"
          >
            <p class="px-2 font-weight-bold text-mid">{{ item.pit }}</p>
          </div>
        </template>
        <template v-slot:cell(type_ob)="{ item }">
          <div
            v-for="(n, i) in item.volume_item.length + 1"
            :key="i"
            class="p-2 m-0 cell"
            :class="i === item.volume_item.length ? '' : 'border-bottom'"
            :style="i !== item.volume_item.length ? item.volume_item[i].status_payment.key === 'Pay' ? 'background-color: #E9FBF9' : 'background-color: #EAE7F3' : 'background-color: #9ed7d2;font-weight: bold'"
          >
            <span v-if="i === item.volume_item.length"></span>
            <validation-provider
              v-else
              rules="required"
              v-slot="{ errors }"
              slim
              class="flex-fill"
            >
              <v-select
                v-model="item.volume_item[i].type"
                :clearable="false"
                :options="typeOB"
                :class="{ 'is-invalid': errors.length }"
                disabled
              />
            </validation-provider>
          </div>
        </template>
        <template v-slot:cell(status_payment)="{ item }">
          <div
            v-for="(n, i) in item.volume_item.length + 1"
            :key="i"
            class="p-2 m-0 cell"
            :class="i === item.volume_item.length ? '' : 'border-bottom'"
            :style="i !== item.volume_item.length ? item.volume_item[i].status_payment.key === 'Pay' ? 'background-color: #E9FBF9' : 'background-color: #EAE7F3' : 'background-color: #9ed7d2;font-weight: bold'"
          >
            <span v-if="i === item.volume_item.length"></span>
            <validation-provider
              v-else
              rules="required"
              v-slot="{ errors }"
              slim
              class="flex-fill"
            >
              <v-select
                v-model="item.volume_item[i].status_payment.key"
                :clearable="false"
                :options="statusPaymentOptions"
                label="key"
                :reduce="({ key }) => key"
                :class="{ 'is-invalid': errors.length }"
              />
            </validation-provider>
          </div>
        </template>
        <template v-slot:cell(actual_distance)="{ item }">
          <div
            v-for="(n, i) in item.volume_item.length + 1"
            :key="i"
            class="p-2 cell d-flex align-items-center justify-content-left"
            :class="i === item.volume_item.length ? '' : 'border-bottom'"
            :style="i !== item.volume_item.length ? item.volume_item[i].status_payment.key === 'Pay' ? 'background-color: #E9FBF9' : 'background-color: #EAE7F3' : 'background-color: #9ed7d2;font-weight: bold'"
          >
            <span v-if="i === item.volume_item.length"></span>
            <validation-provider
              v-else
              name="Actual Distance"
              rules="required"
              v-slot="{ errors }"
              slim
              class="flex-fill"
              >
              <b-form-input
                :value="formatMoney(parseFloat(item.volume_item[i].actual_distance), { symbol: '', precision: '2', thousand: ',' })"
                size="sm"
                disabled
                :class="{ 'is-invalid': errors.length }"
              />
            </validation-provider>
          </div>
        </template>
        <template v-slot:cell(volume)="{ item }">
          <div
            v-for="(n, i) in item.volume_item.length + 1"
            :key="i"
            class="p-2 cell d-flex align-items-center justify-content-left"
            :class="i === item.volume_item.length ? '' : 'border-bottom'"
            :style="i !== item.volume_item.length ? item.volume_item[i].status_payment.key === 'Pay' ? 'background-color: #E9FBF9' : 'background-color: #EAE7F3' : 'background-color: #9ed7d2;font-weight: bold'"
          >
            <span v-if="i === item.volume_item.length">
              {{
                  formatMoney(
                    parseFloat(subTotal(item.volume_item, 'volume')),
                    { symbol: '', precision: '2', thousand: ',' }
                  )
              }}
            </span>
            <validation-provider
              v-else
              name="Volume Coal Auxiliary"
              rules="required"
              v-slot="{ errors }"
              slim
              class="flex-fill"
              >
              <b-form-input
                :value="formatMoney(parseFloat(item.volume_item[i].volume), { symbol: '', precision: '2', thousand: ',' })"
                size="sm"
                disabled
                :class="{ 'is-invalid': errors.length }"
              />
            </validation-provider>
          </div>
        </template>
        <template v-slot:cell(unit_price)="{ item }">
          <div
            v-for="(n, i) in item.volume_item.length + 1"
            :key="i"
            class="p-2 cell d-flex align-items-center justify-content-left"
            :class="i === item.volume_item.length ? '' : 'border-bottom'"
            :style="i !== item.volume_item.length ? item.volume_item[i].status_payment.key === 'Pay' ? 'background-color: #E9FBF9' : 'background-color: #EAE7F3' : 'background-color: #9ed7d2;font-weight: bold'"
          >
            <span v-if="i === item.volume_item.length"></span>
            <validation-provider
              v-else
              name="Unit Price"
              rules="required"
              v-slot="{ errors }"
              slim
              class="flex-fill"
              >
              <b-form-input
                autocapitalize="off"
                :value="formatMoney(parseFloat(item.volume_item[i].unit_price), { symbol: '', precision: '2', thousand: ',' })"
                size="sm"
                autocomplete="off"
                disabled
                :class="{ 'is-invalid': errors.length }"
              />
            </validation-provider>
          </div>
        </template>
        <template v-slot:cell(total_price)="{ item }">
          <div
            v-for="(n, i) in item.volume_item.length + 1"
            :key="i"
            class="p-2 cell d-flex align-items-center justify-content-left"
            :class="i === item.volume_item.length ? '' : 'border-bottom'"
            :style="i !== item.volume_item.length ? item.volume_item[i].status_payment.key === 'Pay' ? 'background-color: #E9FBF9' : 'background-color: #EAE7F3' : 'background-color: #9ed7d2;font-weight: bold'"
          >
            <span v-if="i === item.volume_item.length">
              {{
                  formatMoney(
                    parseFloat(subTotal(item.volume_item, 'total_price')),
                    { symbol: '', precision: '2', thousand: ',' }
                  )
              }}
            </span>
            <b-form-input
              v-else
              autocapitalize="off"
              :value="formatMoney(parseFloat(item.volume_item[i].total_price), { symbol: '', precision: '2', thousand: ',' })"
              size="sm"
              autocomplete="off"
              disabled
            />
          </div>
        </template>
        <template v-slot:cell(budget_number_cc)="{ item, index }">
          <div
            v-for="(n, i) in item.volume_item.length + 1"
            :key="i"
            class="p-2 m-0 cell"
            :class="i === item.volume_item.length ? '' : 'border-bottom'"
            :style="i !== item.volume_item.length ? item.volume_item[i].status_payment.key === 'Pay' ? 'background-color: #E9FBF9' : 'background-color: #EAE7F3' : 'background-color: #fff'"
          >
            <span v-if="i === item.volume_item.length"></span>
            <validation-provider
              v-else
              rules="required"
              v-slot="{ errors }"
              slim
              class="flex-fill"
            >
              <v-select
                v-model="item.volume_item[i].budget_number_cc"
                :clearable="false"
                :options="item.volume_item[i].budget_number_cc_list"
                :class="{ 'is-invalid': errors.length }"
                placeholder="cc"
                @option:selected="fetchBudgetNumber('cc', index, i, [item.volume_item[i].budget_number_cc])"
              />
            </validation-provider>
          </div>
        </template>
        <template v-slot:cell(budget_number_plan)="{ item, index }">
          <div
            v-for="(n, i) in item.volume_item.length + 1"
            :key="i"
            class="p-2 m-0 cell"
            :class="i === item.volume_item.length ? '' : 'border-bottom'"
            :style="i !== item.volume_item.length ? item.volume_item[i].status_payment.key === 'Pay' ? 'background-color: #E9FBF9' : 'background-color: #EAE7F3' : 'background-color: #fff'"
          >
            <span v-if="i === item.volume_item.length"></span>
            <validation-provider
              v-else
              rules="required"
              v-slot="{ errors }"
              slim
              class="flex-fill"
            >
              <v-select
                v-model="item.volume_item[i].budget_number_plan"
                :clearable="false"
                :options="item.volume_item[i].budget_number_plan_list"
                :class="{ 'is-invalid': errors.length }"
                placeholder="plan"
                @option:selected="fetchBudgetNumber('plan', index, i, [item.volume_item[i].budget_number_cc, item.volume_item[i].budget_number_plan])"
              />
            </validation-provider>
          </div>
        </template>
        <template v-slot:cell(budget_number_ac)="{ item, index }">
          <div
            v-for="(n, i) in item.volume_item.length + 1"
            :key="i"
            class="p-2 m-0 cell"
            :class="i === item.volume_item.length ? '' : 'border-bottom'"
            :style="i !== item.volume_item.length ? item.volume_item[i].status_payment.key === 'Pay' ? 'background-color: #E9FBF9' : 'background-color: #EAE7F3' : 'background-color: #fff'"
          >
            <span v-if="i === item.volume_item.length"></span>
            <validation-provider
              v-else
              rules="required"
              v-slot="{ errors }"
              slim
              class="flex-fill"
            >
              <v-select
                v-model="item.volume_item[i].budget_number_ac"
                :clearable="false"
                :options="item.volume_item[i].budget_number_ac_list"
                :class="{ 'is-invalid': errors.length }"
                placeholder="ac"
                @option:selected="fetchBudgetNumber('ac', index, i, [item.volume_item[i].budget_number_cc, item.volume_item[i].budget_number_plan, item.volume_item[i].budget_number_ac])"
              />
            </validation-provider>
          </div>
        </template>
        <template v-slot:cell(budget_number_sub_ac)="{ item, index }">
          <div
            v-for="(n, i) in item.volume_item.length + 1"
            :key="i"
            class="p-2 m-0 cell"
            :class="i === item.volume_item.length ? '' : 'border-bottom'"
            :style="i !== item.volume_item.length ? item.volume_item[i].status_payment.key === 'Pay' ? 'background-color: #E9FBF9' : 'background-color: #EAE7F3' : 'background-color: #fff'"
          >
            <span v-if="i === item.volume_item.length"></span>
            <validation-provider
              v-else
              rules="required"
              v-slot="{ errors }"
              slim
              class="flex-fill"
            >
              <v-select
                v-model="item.volume_item[i].budget_number_sub_ac"
                :clearable="false"
                :options="item.volume_item[i].budget_number_sub_ac_list"
                :class="{ 'is-invalid': errors.length }"
                placeholder="sub ac"
                @option:selected="fetchBudgetNumber('sub_ac', index, i, [item.volume_item[i].budget_number_cc, item.volume_item[i].budget_number_plan, item.volume_item[i].budget_number_ac, item.volume_item[i].budget_number_sub_ac])"
              />
            </validation-provider>
          </div>
        </template>
        <template v-slot:cell(budget_number_pa)="{ item }">
          <div
            v-for="(n, i) in item.volume_item.length + 1"
            :key="i"
            class="p-2 m-0 cell"
            :class="i === item.volume_item.length ? '' : 'border-bottom'"
            :style="i !== item.volume_item.length ? item.volume_item[i].status_payment.key === 'Pay' ? 'background-color: #E9FBF9' : 'background-color: #EAE7F3' : 'background-color: #fff'"
          >
            <span v-if="i === item.volume_item.length"></span>
            <validation-provider
              v-else
              rules="required"
              v-slot="{ errors }"
              slim
              class="flex-fill"
            >
              <v-select
                v-model="item.volume_item[i].budget_number_pa"
                :clearable="false"
                :options="item.volume_item[i].budget_number_pa_list"
                :class="{ 'is-invalid': errors.length }"
                placeholder="pa"
              />
            </validation-provider>
          </div>
        </template>
      </b-table>
      <br>
      <h5>List Pending From Previous Month</h5>
      <b-table
        class="mt-2 p-0"
        table-class="table-overburden"
        thead-class="bg-color text-center"
        empty-text="No data"
        :items="detailPreviousMonth"
        :fields="previousMonthFields"
        responsive
        show-empty
        bordered
        ref="editPrevTable"
      >
        <template #thead-top>
          <b-tr>
            <b-th rowspan="2">Month</b-th>
            <b-th rowspan="2">Pit</b-th>
            <b-th rowspan="2">Type OB</b-th>
            <b-th rowspan="2">Status Payment</b-th>
            <b-th rowspan="2">Actual Distance</b-th>
            <b-th rowspan="2">Volume OB</b-th>
            <b-th rowspan="2">Unit Price (IDR/Ton)</b-th>
            <b-th rowspan="2">Total Price (IDR/Ton)</b-th>
            <b-th colspan="5" class="text-center">Budget Number</b-th>
          </b-tr>
        </template>
        <template v-slot:cell(periode_doc)="items">
          <div
            :class="items.item.status_payment.key === 'Pay' ? 'pay-background' : 'pending-background'"
          >
            <p class="p-2 pb-0 font-weight-bold mt-2 color-date" style="width:150px">{{ items.item.periode_doc }}</p>
          </div>

        </template>
        <template v-slot:cell(pit)="items">
          <div
            :class="items.item.status_payment.key === 'Pay' ? 'pay-background' : 'pending-background'"
          >
            <p class="p-2 pb-0 font-weight-bold mt-2" style="width:100px;">{{ items.item.pit }}</p>
          </div>
        </template>
        <template v-slot:cell(type_ob)="{ item }">
          <div
            class="p-2 m-0"
            :class="item.status_payment.key === 'Pay' ? 'pay-background' : 'pending-background'"
          >
            <validation-provider
              rules="required"
              v-slot="{ errors }"
              slim
              class="flex-fill"
            >
              <v-select
                v-model="item.type"
                :clearable="false"
                :options="typeOB"
                :class="{ 'is-invalid': errors.length }"
                disabled
              />
            </validation-provider>
          </div>
        </template>
        <template v-slot:cell(status_payment)="{ item }">
          <div
            class="p-2 m-0"
            style="width:250px"
            :class="item.status_payment.key === 'Pay' ? 'pay-background' : 'pending-background'"
          >
            <validation-provider
              rules="required"
              v-slot="{ errors }"
              slim
              class="flex-fill"
            >
              <v-select
                v-model="item.status_payment"
                :clearable="false"
                :options="statusPaymentOptions"
                label="label"
                :class="{ 'is-invalid': errors.length }"
              />
            </validation-provider>
          </div>
        </template>
        <template v-slot:cell(actual_distance)="{ item }">
          <div
            class="p-2 cell"
            :class="item.status_payment.key === 'Pay' ? 'pay-background' : 'pending-background'"
          >
            <validation-provider
              name="Actual Distance"
              rules="required"
              v-slot="{ errors }"
              slim
              class="flex-fill"
              >
              <b-form-input
                :value="formatMoney(parseFloat(item.actual_distance), { symbol: '', precision: '2', thousand: ',' })"
                size="sm"
                disabled
                :class="{ 'is-invalid': errors.length }"
              />
            </validation-provider>
          </div>
        </template>
        <template v-slot:cell(volume)="{ item }">
          <div
            class="p-2 cell"
            :class="item.status_payment.key === 'Pay' ? 'pay-background' : 'pending-background'"
          >
            <validation-provider
              name="Volume Coal Auxiliary"
              rules="required"
              v-slot="{ errors }"
              slim
              class="flex-fill"
              >
              <b-form-input
                :value="formatMoney(parseFloat(item.volume), { symbol: '', precision: '2', thousand: ',' })"
                size="sm"
                disabled
                :class="{ 'is-invalid': errors.length }"
              />
            </validation-provider>
          </div>
        </template>
        <template v-slot:cell(unit_price)="{ item }">
          <div
            class="p-2 cell"
            :class="item.status_payment.key === 'Pay' ? 'pay-background' : 'pending-background'"
          >
            <validation-provider
              name="Unit Price"
              rules="required"
              v-slot="{ errors }"
              slim
              class="flex-fill"
              >
              <b-form-input
                autocapitalize="off"
                :value="formatMoney(parseFloat(item.unit_price), { symbol: '', precision: '2', thousand: ',' })"
                size="sm"
                autocomplete="off"
                disabled
                :class="{ 'is-invalid': errors.length }"
              />
            </validation-provider>
          </div>
        </template>
        <template v-slot:cell(total_price)="{ item }">
          <div
            class="p-2 cell"
            :class="item.status_payment.key === 'Pay' ? 'pay-background' : 'pending-background'"
          >
            <b-form-input
              autocapitalize="off"
              :value="formatMoney(parseFloat(item.total_price), { symbol: '', precision: '2', thousand: ',' })"
              size="sm"
              autocomplete="off"
              disabled
            />
          </div>
        </template>
        <template v-slot:cell(budget_number_cc)="{ item, index }">
          <div
            class="p-2 m-0"
            :class="item.status_payment.key === 'Pay' ? 'pay-background' : 'pending-background'"
          >
            <validation-provider
              rules="required"
              v-slot="{ errors }"
              slim
              class="flex-fill"
            >
              <v-select
                v-model="item.budget_number_cc"
                :clearable="false"
                :options="item.budget_number_cc_list"
                :class="{ 'is-invalid': errors.length }"
                placeholder="cc"
                @option:selected="fetchBudgetNumber('cc_prev', index, 0, [item.budget_number_cc])"
              />
            </validation-provider>
          </div>
        </template>
        <template v-slot:cell(budget_number_plan)="{ item, index }">
          <div
            class="p-2 m-0"
            :class="item.status_payment.key === 'Pay' ? 'pay-background' : 'pending-background'"
          >
          <validation-provider
              rules="required"
              v-slot="{ errors }"
              slim
              class="flex-fill"
            >
              <v-select
                v-model="item.budget_number_plan"
                :clearable="false"
                :options="item.budget_number_plan_list"
                :class="{ 'is-invalid': errors.length }"
                placeholder="plan"
                @option:selected="fetchBudgetNumber('plan_prev', index, 0, [item.budget_number_cc, item.budget_number_plan])"
              />
            </validation-provider>
          </div>
        </template>
        <template v-slot:cell(budget_number_ac)="{ item, index }">
          <div
            class="p-2 m-0"
            :class="item.status_payment.key === 'Pay' ? 'pay-background' : 'pending-background'"
          >
            <validation-provider
              rules="required"
              v-slot="{ errors }"
              slim
              class="flex-fill"
            >
              <v-select
                v-model="item.budget_number_ac"
                :clearable="false"
                :options="item.budget_number_ac_list"
                :class="{ 'is-invalid': errors.length }"
                placeholder="ac"
                @option:selected="fetchBudgetNumber('ac_prev', index, 0, [item.budget_number_cc, item.budget_number_plan, item.budget_number_ac])"
              />
            </validation-provider>
          </div>
        </template>
        <template v-slot:cell(budget_number_sub_ac)="{ item, index }">
          <div
            class="p-2 m-0"
            :class="item.status_payment.key === 'Pay' ? 'pay-background' : 'pending-background'"
          >
            <validation-provider
              rules="required"
              v-slot="{ errors }"
              slim
              class="flex-fill"
            >
              <v-select
                v-model="item.budget_number_sub_ac"
                :clearable="false"
                :options="item.budget_number_sub_ac_list"
                :class="{ 'is-invalid': errors.length }"
                placeholder="sub ac"
                @option:selected="fetchBudgetNumber('sub_ac_prev', index, 0, [item.budget_number_cc, item.budget_number_plan, item.budget_number_ac, item.budget_number_sub_ac])"
              />
            </validation-provider>
          </div>
        </template>
        <template v-slot:cell(budget_number_pa)="{ item }">
          <div
            class="p-2 m-0"
            :class="item.status_payment.key === 'Pay' ? 'pay-background' : 'pending-background'"
          >
            <validation-provider
              rules="required"
              v-slot="{ errors }"
              slim
              class="flex-fill"
            >
              <v-select
                v-model="item.budget_number_pa"
                :clearable="false"
                :options="item.budget_number_pa_list"
                :class="{ 'is-invalid': errors.length }"
                placeholder="pa"
              />
            </validation-provider>
          </div>
        </template>
        <template v-slot:custom-foot>
          <tr class="bg-color text-center">
            <td class="font-weight-bold">Sub Total</td>
            <td></td>
            <td></td>
            <td></td>
            <td>
              {{
                formatMoney(
                  parseFloat(subTotal(detailPreviousMonth, 'actual_distance')),
                  { symbol: '', precision: '2', thousand: ',' }
                )
              }}
            </td>
            <td>
              {{
                formatMoney(
                  parseFloat(subTotal(detailPreviousMonth, 'volume')),
                  { symbol: '', precision: '2', thousand: ',' }
                )
              }}
            </td>
            <td>
              {{
                formatMoney(
                  parseFloat(subTotal(detailPreviousMonth, 'unit_price')),
                  { symbol: '', precision: '2', thousand: ',' }
                )
              }}
            </td>
            <td>
              {{
                formatMoney(
                  parseFloat(subTotal(detailPreviousMonth, 'total_price')),
                  { symbol: '', precision: '2', thousand: ',' }
                )
              }}
            </td>
            <td colspan="5"></td>
          </tr>
        </template>
      </b-table>
    </div>
    <br>
    <b-table
      class="mt-2"
      responsive
    >
      <template v-slot:custom-foot>
        <tr class="bg-color total border-top">
          <td class="font-weight-bold border-right">Total OB Removal Payable Current Month</td>
          <td class="font-weight-bold text-right">{{ formatMoney(parseFloat(generateTotalOBCurrentMonth()), { symbol: '', precision: '2', thousand: ',' }) }}</td>
        </tr>
        <tr class="bg-color total">
          <td class="font-weight-bold border-right">Total OB Removal Adjusment to Next Month</td>
          <td class="font-weight-bold text-right">{{ formatMoney(parseFloat(generateTotalOBNextMonth()), { symbol: '', precision: '2', thousand: ',' }) }}</td>
        </tr>
      </template>
    </b-table>
    <br>
    <h6 class="font-weight-bold">Attachment Supporting Document</h6>
    <div
      v-if="attachment.length && !isEdit"
      :style="gridStyle"
      class="card-list mt-2 p-0"
    >
      <div
        v-for="(item, index) in attachment"
        :key="index"
      >
        <div
          class="dropbox-files mx-1 mb-2"
          style="cursor: pointer;"
          @click="downloadFile(item.url)"
        >
          <div
            class="background-file"
          >
            <img
              v-if="checkType(item.file_name) === attachmentType[0] || checkType(item.file_name) === attachmentType[1]"
              class="my-4"
              src="@/assets/icon-excel.png"
              width="70"
              height="70"
            >
            <img
              v-else-if="checkType(item.file_name) === attachmentType[4]"
              class="my-4"
              src="@/assets/icon-pdf.png"
              width="70"
              height="70"
            >
            <img
              v-else-if="checkType(item.file_name) === attachmentType[2] || checkType(item.file_name) === attachmentType[3]"
              class="my-4"
              src="@/assets/icon-word.png"
              width="70"
              height="70"
            >
          </div>
          <div
            class="d-flex justify-content-between text"
          >
            <p class="text-ellipsis">{{ item ? item.file_name : 'NaN'}}</p>
            <p class="size-file">{{ item ? item.size : 'NaN mb'}}</p>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="!attachment.length && !isEdit" class="w-100 text-center">No Attachment</div>
    <div
      v-else-if="isEdit"
      class="mt-4"
    >
        <div class="dropbox">
          <input
            type="file"
            @change="onChangeFile($event.target.files)"
            class="input-file"
            multiple
            accept=".xls, .xlsx, .doc, .docx, .pdf"
          >
            <img
              class="mt-2"
              src="@/assets/icon-upload.png"
              width="100"
              height="100"
            >
            <div>
              <p id="text-dropbox">Drag or klik button to upload file</p>
            </div>
            <b-button
              class="btn-custom"
              variant="info"
              size="sm"
            >
              Browse File
            </b-button>
        </div>
        <div
          v-if="attachment.length && !isUpload"
          :style="gridStyle"
          class="card-list mt-4 p-0"
          id="attachment"
          ref="attachment"
        >
          <div
            v-for="(item, index) in attachment"
            :key="index"
            class="supporting-file"
          >
            <div
              class="dropbox-files mx-1 mb-2"
            >
              <div
                class="background-file"
              >
                <div class="d-flex justify-content-end">
                  <img
                    class="mr-2 mt-2"
                    src="@/assets/icon-trash.png"
                    width="25"
                    height="25"
                    style="cursor: pointer"
                    @click="removeFile(index, item.id)"
                  >
                </div>
                <img
                  v-if="checkType(item.file_name) === attachmentType[0] || checkType(item.file_name) === attachmentType[1]"
                  class="mb-4"
                  src="@/assets/icon-excel.png"
                  width="70"
                  height="70"
                >
                <img
                  v-else-if="checkType(item.file_name) === attachmentType[4]"
                  class="mb-4"
                  src="@/assets/icon-pdf.png"
                  width="70"
                  height="70"
                >
                <img
                  v-else-if="checkType(item.file_name) === attachmentType[2] || checkType(item.file_name) === attachmentType[3]"
                  class="mb-4"
                  src="@/assets/icon-word.png"
                  width="70"
                  height="70"
                >
              </div>
              <div
                class="d-flex justify-content-between text"
              >
                <p class="text-ellipsis">{{ item ? item.file_name : 'NaN'}}</p>
                <p class="size-file">{{ item ? item.size : 'NaN mb'}}</p>
              </div>
            </div>
          </div>
        </div>
        <div v-if="isUpload">
          <b-spinner label="Loading..."></b-spinner>
        </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { formatMoney } from 'accounting-js'

export default {
  props: {
    detailCurrentMonth: {
      type: Array,
      default: () => []
    },
    detailPreviousMonth: {
      type: Array,
      default: () => []
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    attachment: {
      type: Array,
      default: () => ([])
    }
  },
  data: () => ({
    fields: [
      { key: 'pit', label: 'Pit', sortable: false, tdClass: 'text-center align-middle p-0', thClass: 'hidden-header' },
      { key: 'type_ob', label: 'Type OB', tdClass: 'text-center p-0', thClass: 'hidden-header', thStyle: 'width: 150px' },
      { key: 'status_payment', label: 'Status Payment', tdClass: 'text-center p-0', thClass: 'hidden-header', thStyle: 'width: 70px' },
      { key: 'actual_distance', label: 'Actual Distance', tdClass: 'text-right p-0', thClass: 'hidden-header', thStyle: 'width: 70px' },
      { key: 'volume', label: 'Volume OB', tdClass: 'text-right p-0', thClass: 'hidden-header', thStyle: 'width: 70px' },
      { key: 'unit_price', label: 'Unit Price (IDR/BCM)', tdClass: 'text-right p-0', thClass: 'hidden-header', thStyle: 'width: 70px' },
      { key: 'total_price', label: 'Total Price (IDR)', tdClass: 'text-right p-0', thClass: 'hidden-header', thStyle: 'width: 70px' },
      { key: 'budget_number_cc', label: 'CC', tdClass: 'text-center p-0', thStyle: 'width: 100px' },
      { key: 'budget_number_plan', label: 'Plan', tdClass: 'text-center p-0', thStyle: 'width: 100px' },
      { key: 'budget_number_ac', label: 'A/C', tdClass: 'text-center p-0', thStyle: 'width: 100px' },
      { key: 'budget_number_sub_ac', label: 'Sub A/C', tdClass: 'text-center p-0', thStyle: 'width: 100px' },
      { key: 'budget_number_pa', label: 'P/A', tdClass: 'text-center p-0', thStyle: 'width: 100px' }
    ],
    previousMonthFields: [
      { key: 'periode_doc', label: 'Month', tdClass: 'text-center align-middle p-0', thClass: 'hidden-header', thStyle: 'width: 200px' },
      { key: 'pit', label: 'Pit', tdClass: 'text-center align-middle p-0', thClass: 'hidden-header', thStyle: 'width: 150px' },
      { key: 'type_ob', label: 'Type OB', tdClass: 'text-center p-0', thClass: 'hidden-header' },
      { key: 'status_payment', label: 'Status Payment', tdClass: 'text-center p-0', thClass: 'hidden-header' },
      { key: 'actual_distance', label: 'Actual Distance', tdClass: 'text-right p-0', thClass: 'hidden-header', thStyle: 'width: 70px' },
      { key: 'volume', label: 'Volume OB', tdClass: 'text-right p-0', thClass: 'hidden-header', thStyle: 'width: 70px' },
      { key: 'unit_price', label: 'Unit Price (IDR/BCM)', tdClass: 'text-right p-0', thClass: 'hidden-header', thStyle: 'width: 70px' },
      { key: 'total_price', label: 'Total Price (IDR)', tdClass: 'text-right p-0', thClass: 'hidden-header', thStyle: 'width: 70px' },
      { key: 'budget_number_cc', label: 'CC', tdClass: 'text-center p-0', thStyle: 'width: 100px' },
      { key: 'budget_number_plan', label: 'Plan', tdClass: 'text-center p-0', thStyle: 'width: 100px' },
      { key: 'budget_number_ac', label: 'A/C', tdClass: 'text-center p-0', thStyle: 'width: 100px' },
      { key: 'budget_number_sub_ac', label: 'Sub A/C', tdClass: 'text-center p-0', thStyle: 'width: 100px' },
      { key: 'budget_number_pa', label: 'P/A', tdClass: 'text-center p-0', thStyle: 'width: 100px' }
    ],
    numberOfColumns: 4,
    attachmentType: ['xlsx', 'xls', 'doc', 'docx', 'pdf'],
    typeOB: ['OB', 'MUD', 'COAL', 'NORMAL'],
    statusPaymentOptions: [{ key: 'Pay', label: 'Pay from Previous Month' }, { key: 'Pending', label: 'Carry Over to Next Month' }],
    isUpload: false
  }),
  computed: {
    gridStyle() {
      return {
        gridTemplateColumns: `repeat(${this.numberOfColumns}, minmax(25%, 1fr))`
      }
    }
  },
  methods: {
    formatMoney,
    checkType(fileName) {
      const splitFileName = fileName.split('.')
      return splitFileName[splitFileName.length - 1]
    },
    getTotalOBCurrentMonth(paymentType) {
      let totalObCurrentMonth = 0
      this.detailCurrentMonth.map(v => {
        v.volume_item.map(i => {
          if (i.status_payment.key === paymentType) {
            totalObCurrentMonth += i.total_price
          }
        })
      })
      return totalObCurrentMonth
    },
    getTotalOBNextMonth(paymentType) {
      let totalObPrev = 0
      this.detailPreviousMonth.map(v => {
        if (v.status_payment.key === paymentType) {
          totalObPrev += v.total_price
        }
      })
      return totalObPrev
    },
    generateTotalOBCurrentMonth() {
      return this.getTotalOBCurrentMonth('Pay') + this.getTotalOBNextMonth('Pay')
    },
    generateTotalOBNextMonth() {
      return this.getTotalOBCurrentMonth('Pending') + this.getTotalOBNextMonth('Pending')
    },
    async removeFile(index, fileId) {
      try {
        this.attachment.splice(index, 1)
        await api.overburden.deleteAttachment(fileId)
      } catch ({ response }) {
        this.$nextTick(() => {
          this.$bvToast.toast(`${response.status} - ${response.data.error.message}`, {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        })
      }
    },
    async onChangeFile(value) {
      let isTypeAllowed = true
      let isSizeAllowed = true
      if (value.length + this.attachment.length > 10) {
        this.$nextTick(() => {
          this.$bvToast.toast('maximum file to upload only 10 files', {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        })
        return
      }
      const formData = new FormData()
      for (let i = 0; i < value.length; i++) {
        const nameFile = value[i].name.split('.')
        if ((this.attachmentType.includes(nameFile[nameFile.length - 1]))) {
          if (value[i].size < 3072000) {
            formData.append('overburden_file', value[i])
          } else {
            isSizeAllowed = false
            break
          }
        } else {
          isTypeAllowed = false
          break
        }
      }
      if (!isTypeAllowed) {
        this.$nextTick(() => {
          this.$bvToast.toast('Only PDF, Excel and Doc files are allowed.', {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        })
      }

      if (!isSizeAllowed) {
        this.$nextTick(() => {
          this.$bvToast.toast('Max size file 3 mb.', {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        })
      }
      if (isTypeAllowed && isSizeAllowed) {
        this.isUpload = true
        await this.uploadAttachment(formData)
      }
    },
    async uploadAttachment(formData) {
      try {
        await api.overburden.uploadAttachment(this.$route.params.id, formData, { onUploadProgress: this.setUploadProgress })
        setTimeout(() => {
          this.$emit('upload')
        }, 3000)
        this.$refs.attachment.refresh()
      } catch ({ response }) {
        this.$nextTick(() => {
          this.$bvToast.toast(`${response.status} - ${response.data.error.message}`, {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
        })
      }
      this.isUpload = false
    },
    async fetchBudgetNumber(code, index, i, value) {
      if (code === 'cc') {
        const data = await api.backupPayment.plan({
          cc: value[0]
        })
        this.detailCurrentMonth[index].volume_item[i].budget_number_plan = null
        this.detailCurrentMonth[index].volume_item[i].budget_number_ac = null
        this.detailCurrentMonth[index].volume_item[i].budget_number_sub_ac = null
        this.detailCurrentMonth[index].volume_item[i].budget_number_pa = null
        this.detailCurrentMonth[index].volume_item[i].budget_number_plan_list = []
        this.detailCurrentMonth[index].volume_item[i].budget_number_ac_list = []
        this.detailCurrentMonth[index].volume_item[i].budget_number_sub_ac_list = []
        this.detailCurrentMonth[index].volume_item[i].budget_number_pa_list = []
        this.detailCurrentMonth[index].volume_item[i].budget_number_plan_list = data
      } else if (code === 'plan') {
        this.detailCurrentMonth[index].volume_item[i].budget_number_ac = null
        this.detailCurrentMonth[index].volume_item[i].budget_number_sub_ac = null
        this.detailCurrentMonth[index].volume_item[i].budget_number_pa = null
        this.detailCurrentMonth[index].volume_item[i].budget_number_ac_list = []
        this.detailCurrentMonth[index].volume_item[i].budget_number_sub_ac_list = []
        this.detailCurrentMonth[index].volume_item[i].budget_number_pa_list = []
        this.detailCurrentMonth[index].volume_item[i].budget_number_ac_list = await api.backupPayment.ac({
          cc: value[0],
          plan: value[1]
        })
      } else if (code === 'ac') {
        this.detailCurrentMonth[index].volume_item[i].budget_number_sub_ac = null
        this.detailCurrentMonth[index].volume_item[i].budget_number_pa = null
        this.detailCurrentMonth[index].volume_item[i].budget_number_sub_ac_list = []
        this.detailCurrentMonth[index].volume_item[i].budget_number_pa_list = []
        this.detailCurrentMonth[index].volume_item[i].budget_number_sub_ac_list = await api.backupPayment.subAC({
          cc: value[0],
          plan: value[1],
          ac: value[2]
        })
      } else if (code === 'sub_ac') {
        this.detailCurrentMonth[index].volume_item[i].budget_number_pa = null
        this.detailCurrentMonth[index].volume_item[i].budget_number_pa_list = await api.backupPayment.pa({
          cc: value[0],
          plan: value[1],
          ac: value[2],
          sub_ac: value[3]
        })
      } else if (code === 'cc_prev') {
        const data = await api.backupPayment.plan({
          cc: value[0]
        })
        this.detailPreviousMonth[index].budget_number_plan = null
        this.detailPreviousMonth[index].budget_number_ac = null
        this.detailPreviousMonth[index].budget_number_sub_ac = null
        this.detailPreviousMonth[index].budget_number_pa = null
        this.detailPreviousMonth[index].budget_number_plan_list = []
        this.detailPreviousMonth[index].budget_number_ac_list = []
        this.detailPreviousMonth[index].budget_number_sub_ac_list = []
        this.detailPreviousMonth[index].budget_number_pa_list = []
        this.detailPreviousMonth[index].budget_number_plan_list = data
      } else if (code === 'plan_prev') {
        this.detailPreviousMonth[index].budget_number_ac = null
        this.detailPreviousMonth[index].budget_number_sub_ac = null
        this.detailPreviousMonth[index].budget_number_pa = null
        this.detailPreviousMonth[index].budget_number_ac_list = []
        this.detailPreviousMonth[index].budget_number_sub_ac_list = []
        this.detailPreviousMonth[index].budget_number_pa_list = []
        this.detailPreviousMonth[index].budget_number_ac_list = await api.backupPayment.ac({
          cc: value[0],
          plan: value[1]
        })
      } else if (code === 'ac_prev') {
        this.detailPreviousMonth[index].budget_number_sub_ac = null
        this.detailPreviousMonth[index].budget_number_pa = null
        this.detailPreviousMonth[index].budget_number_sub_ac_list = []
        this.detailPreviousMonth[index].budget_number_pa_list = []
        this.detailPreviousMonth[index].budget_number_sub_ac_list = await api.backupPayment.subAC({
          cc: value[0],
          plan: value[1],
          ac: value[2]
        })
      } else if (code === 'sub_ac_prev') {
        this.detailPreviousMonth[index].budget_number_pa = null
        this.detailPreviousMonth[index].budget_number_pa_list = await api.backupPayment.pa({
          cc: value[0],
          plan: value[1],
          ac: value[2],
          sub_ac: value[3]
        })
      }
      this.$refs.editCurrTable.refresh()
      this.$refs.editPrevTable.refresh()
    },
    downloadFile(url) {
      window.open(url)
    },
    subTotal(value, key) {
      let x = 0
      value.map(v => {
        x += v[key]
      })
      return x
    }
  }
}
</script>

<style lang="scss">
.form-control {
  font-size: 12px;
}

.col-form-label, .col-form-label-sm {
  font-size: 12px !important;
}

.total {
  font-size: 16px;
}

.text {
  height: fit-content;
  margin-top: 3px;
}

.text p {
  font-size: 14px;
}

.cell {
  height: 51px;
}

.background-file {
  background-color: #DBF9F6;
  border-radius: 16px;
}

.size-file {
  color: #D0C9D6;
}

#text-dropbox {
  font-size: 16px;
  text-align: center;
}

.dropbox {
  border: 2px dashed #463191;
  padding: 10px 10px;
  min-height: 150px;
  position: relative;
  border-radius: 16px;
  text-align: center;
  cursor: pointer;
}

.dropbox-files {
  border: 2px dashed #463191;
  padding: 10px 10px;
  min-height: 130px;
  position: relative;
  border-radius: 16px;
  text-align: center;
}

.input-file {
  margin-top: -12px;
  left: 0;
  opacity: 0;
  width: 100%;
  height: 220px;
  position: absolute;
  cursor: pointer;
}
.dropbox p {
  font-size: 12px;
  text-align: center;
  padding-top: 20px;
}

.card-list {
  display: grid;
  grid-gap: 2px;
}

.text-ellipsis {
  font-size: 1px;
  max-width: 200px;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.text-mid {
  padding-top: 13px;
}

.pay-background {
  background-color: #e9fbf9;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width:100%
}

.pending-background {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #EAE7F3;
  height: 100%;
  width:100%
}

.hidden-header {
  display: none;
}

.supporting-file {
  font-size: 12
}

.color-date {
  color: #737AF1;
}

@media print{
  @page {
    size: landscape;
    margin-top: -90px;
  }
}

@media only screen and (max-width: 768px) {
  .dropbox {
    width: 100%;
    position: relative;
  }
}
</style>
